export default "__VITE_ASSET__DWItmi2h__"